import { render, staticRenderFns } from "./CompositeCentersTooltipDialog.vue?vue&type=template&id=37aa9ea1&scoped=true&"
import script from "./CompositeCentersTooltipDialog.vue?vue&type=script&lang=js&"
export * from "./CompositeCentersTooltipDialog.vue?vue&type=script&lang=js&"
import style0 from "./CompositeCentersTooltipDialog.vue?vue&type=style&index=0&id=37aa9ea1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa9ea1",
  null
  
)

export default component.exports